import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import ToggleButton from '../ToggleButton/ToggleButton';

const RepliesCollapseToggleWrapper = ({
  repliesCollapsed,
  handleRepliesCollapseClick,
  repliesCount
}) => {
  return (
    <ToggleButton
      labelView={i18next.t('viewReplies', { count: repliesCount })}
      labelHide={i18next.t('hideReplies', { count: repliesCount })}
      repliesCollapsed={repliesCollapsed}
      handleRepliesCollapseClick={handleRepliesCollapseClick}
    />
  );
};

RepliesCollapseToggleWrapper.propTypes = {
  repliesCollapsed: PropTypes.bool.isRequired,
  handleRepliesCollapseClick: PropTypes.func.isRequired,
  repliesCount: PropTypes.number.isRequired
};

export default RepliesCollapseToggleWrapper;
